import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
function randomSquareCoordinate(position, offset) {
  return position + offset * (Math.random() - 0.5);
}
export var SquareShape = /*#__PURE__*/function () {
  function SquareShape() {
    _classCallCheck(this, SquareShape);
  }
  _createClass(SquareShape, [{
    key: "randomPosition",
    value: function randomPosition(position, size, fill) {
      if (fill) {
        return {
          x: randomSquareCoordinate(position.x, size.width),
          y: randomSquareCoordinate(position.y, size.height)
        };
      } else {
        var halfW = size.width / 2,
          halfH = size.height / 2,
          side = Math.floor(Math.random() * 4),
          v = (Math.random() - 0.5) * 2;
        switch (side) {
          case 0:
            return {
              x: position.x + v * halfW,
              y: position.y - halfH
            };
          case 1:
            return {
              x: position.x - halfW,
              y: position.y + v * halfH
            };
          case 2:
            return {
              x: position.x + v * halfW,
              y: position.y + halfH
            };
          case 3:
          default:
            return {
              x: position.x + halfW,
              y: position.y + v * halfH
            };
        }
      }
    }
  }]);
  return SquareShape;
}();